import { FC, Fragment, useState } from 'react';
import {
  Divider,
  List,
  ListItem,
  ListItemText,
  Collapse,
  IconButton,
  Typography,
  Theme
} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';

import { ExpandLess, ExpandMore } from '@mui/icons-material';
import { IReplacementField } from '../../../../../models';

interface IReplacementFieldsComponent {
  replacementField: IReplacementField;
  copyTextToClipboard: (val: string) => void;
  isDense?: boolean;
}

export const ReplacementField: FC<IReplacementFieldsComponent> = ({
  replacementField,
  copyTextToClipboard,
  isDense
}) => {
  const classes = useStyles({
    isDense
  });
  const [open, setOpen] = useState(false);

  const handleClick = (field: IReplacementField) => {
    if (typeof field.replacementValue === 'string') {
      copyTextToClipboard(field.replacementValue as string);
    }
    if (field.fields && field.fields.length > 0) {
      setOpen(!open);
    }
  };
  return (
    <>
      <ListItem
        button
        dense={isDense}
        className={classes.listButton}
        onClick={() => handleClick(replacementField)}
      >
        <ListItemText
          primary={replacementField.name}
          secondary={replacementField.replacementValue}
        />
        {replacementField.fields && (
          <IconButton
            color="default"
            className={classes.openButton}
            aria-label="open"
            onClick={() => {
              setOpen(!open);
            }}
            size="large"
          >
            {open ? <ExpandLess /> : <ExpandMore />}
          </IconButton>
        )}
      </ListItem>
      <Divider />
      <Collapse in={open} timeout="auto" unmountOnExit className={classes.nested}>
        <List component="div" dense={isDense} disablePadding>
          <>
            {replacementField.fields && replacementField.fields.length > 0 ? (
              replacementField.fields.map(field => (
                <Fragment key={field.name}>
                  <ReplacementField
                    replacementField={field}
                    copyTextToClipboard={copyTextToClipboard}
                  />
                </Fragment>
              ))
            ) : (
              <Typography>{replacementField.replacementValue ?? 'Nothing assigned'}</Typography>
            )}
          </>
        </List>
      </Collapse>
    </>
  );
};

const useStyles = makeStyles<Theme, { isDense?: boolean }>(theme => ({
  root: {
    width: '100%',
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper
  },
  nested: {
    paddingLeft: ({ isDense }) => (isDense ? 0 : theme.spacing(2))
  },
  listItem: {
    paddingTop: 2,
    paddingBottom: 2
  },
  listItemWithCats: {
    paddingTop: 2,
    paddingBottom: 2,
    paddingLeft: theme.spacing(1)
  },
  nestedListItemWithCats: {
    paddingTop: 2,
    paddingBottom: 2,
    paddingLeft: theme.spacing(2)
  },
  buttonWrapper: {
    display: 'flex',
    alignItems: 'center'
  },
  editButton: {
    marginRight: 8,
    padding: 0
  },
  openButton: {
    padding: 0
  },
  listButton: {
    backgroundColor: theme.palette.common.white
  },
  selected: {
    fontWeight: 'bold',
    padding: '2px 8px',
    borderRadius: 5,
    marginRight: 0
  }
}));
